import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const studentWeekOffAPI = createApi({
    reducerPath: 'studentWeekOffAPI',
    baseQuery: defaultBaseQuery,
    tagTypes: ['StudentWeekOff'],
    endpoints: (builder) => ({

        // Same endpoint for add and update - the institute has a single week-off configuration
        saveStudentWeekOff: builder.mutation({
            query: (data) => ({
                url: '/week-off',
                method: 'POST',
                body: data
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ['StudentWeekOff']
        }),

        getStudentWeekOff: builder.query({
            query: () => ({
                url: '/week-off',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ['StudentWeekOff']
        }),

    })
});

export const {
    useSaveStudentWeekOffMutation,
    useGetStudentWeekOffQuery,
} = studentWeekOffAPI;

export default studentWeekOffAPI;
